export const topCell = {
  fontFamily: "Nunito",
  fontStyle: "normal",
  fontWeight: 800,
  fontSize: "16px",
  letterSpacing: "0.005em",
  color: "#3F3F55",
};

export const alert = {
  position: "fixed",
  top: "20px",
  right: "20px",
  zIndex: 2,
  minWidth: "500px",
  minHeight: "50px",
};
